export default __webpack_public_path__ + "8422b61c8899a772c3ac246caff4ba34.jpg";